import { callApi } from './api';
import Setting, { ShippingCarrier } from '@/models/setting';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

const settingsApiUrl = import.meta.env.VITE_API_URL_V1 + '/settings';

export const getSettings = async () => {
    return callApi<Setting>({ url: settingsApiUrl, method: 'GET' });
};

export const useSettings = () => {
    return useQuery({ queryKey: ['settings'], queryFn: getSettings });
};

export type SettingsUpdatePayload = {
    iosForceUpdateVersion?: number | null;
    androidForceUpdateVersion?: number | null;
    iosLatestBuild?: number | null;
    androidLatestBuild?: number | null;
    iosStoreUrl?: string | null;
    androidStoreUrl?: string | null;
    appUpdateMessage?: string | null;
    accessoriesTaxEnabled?: boolean;
    accessoriesShippingRateId?: string | null;
    eventPaymentCardNumber?: string | null;
    eventPaymentIban?: string | null;
    eventPaymentAccountHolder?: string | null;
    eventPaymentInstructions?: string | null;
    /** Send the WHOLE array — the API replaces it wholesale, it does not merge. */
    shippingCarriers?: ShippingCarrier[];
    onboardingDripEnabled?: boolean;
    /**
     * Whether MEMBERS may create their own live audio/video rooms. Ships
     * ABSENT/OFF and the server gate FAILS CLOSED — a member-created room runs on
     * our Cloudflare bandwidth between people we did not put in the room. Staff
     * (coach-led) sessions are unaffected.
     */
    memberLiveSessionsEnabled?: boolean;
};

// PUT /settings is admin-gated server-side. Only whitelisted fields are sent.
export const updateSettings = async (payload: SettingsUpdatePayload) => {
    return callApi<Setting>({ url: settingsApiUrl, method: 'PUT', data: payload });
};

export const useUpdateSettings = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: updateSettings,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['settings'] });
        },
    });
};
